import React from 'react';
import classNames from 'classnames';
import * as styles from './TemplateToolInfo.module.scss';
import { IconType } from 'components/core/Icon/Icon';
import { Inline, Stack } from 'components/layout';
import { Icon, Heading, Text } from 'components/core';

type Props = {
  title: string;
  subTitle: string;
  icon: IconType;
};

export const TemplateToolInfo = ({ title, subTitle, icon }: Props) => {
  const isExtractionOne = subTitle === 'Extraction 1';
  const extractionClass = {
    [styles.ExtractionOne]: isExtractionOne,
    [styles.ExtractionTwo]: !isExtractionOne,
  };
  const iconWrapperClasses = classNames(styles.IconWrapper, extractionClass);
  const subTitleClasses = classNames(styles.SubTitle, extractionClass);

  return (
    <Inline spacing={3}>
      <div className={iconWrapperClasses}>
        <Icon icon={icon} size="xl" inverse={true} />
      </div>
      <Stack>
        <Heading type="h5">{title}</Heading>
        <Text className={subTitleClasses} size="xs">
          {subTitle}
        </Text>
      </Stack>
    </Inline>
  );
};
